import React from 'react';
import easyReplacement from 'assets/images/easy-replacement.png';
import easyReplacementWebp from 'assets/images/easy-replacement.png?as=webp';
import LazyLoad from 'react-lazyload';
import { useSelector } from 'react-redux';
import loadable from '@loadable/component';
import { SUPPORTED_REGIONS } from '../../../shared/enums';
import { selectLocalizationData } from '../../features/localization/localizationSlice';

const FadeIn = loadable(() => import('../common/FadeIn'));

/**
 * @returns {JSX.Element}
 * @constructor
 */
const ReplacementBlock = () => {
  const localization = useSelector(selectLocalizationData);

  return (
    <section className='replacement-block'>
      <div className='container'>
        <h2 className='replacement-block__title'>Easy replacement just 2x/year.</h2>
        <div className='replacement-block__content'>
          {localization.region !== SUPPORTED_REGIONS.SG ? (
            <p>
              You can expect Mila filters to last 6 months, depending on your use.
              {' '}
              <strong>
                We make replacement easy with
                our Auto-Refill program:
              </strong>
              {' '}
              Subscribe at checkout and get filters sent to you every 6 months,
              automatically. Your first filter is free and you can cancel any time.
            </p>
          ) : (
            <p>
              You can expect Mila filters to last 6 months, depending on your use.
              Replacement is easy-peasy, and any of our seven filters will work with your Mila unit.
              Order a new replacement filter
              {' '}
              <a href='/buy/filters'>here</a>
              .
            </p>
          )}
        </div>
        <figure className='replacement-block__image'>
          <LazyLoad>
            <FadeIn>
              <picture>
                <source srcSet={easyReplacementWebp} type='image/webp' />
                <source srcSet={easyReplacement} type='image/png' />
                <img src={easyReplacement} alt='easy-replacement' />
              </picture>
            </FadeIn>
          </LazyLoad>
        </figure>
      </div>
    </section>
  );
};

export default ReplacementBlock;
